import React from "react"
import { StyleSheet, Text, View } from "react-native"

import Base from "../../base"

export default function OrderDetailsItemRow(props) {
  const price = props.formatter.format(
    props.item.quantity * (props.item?.item?.price || props.item?.price || 0),
  )

  const itemShortName =
    props.item?.item?.shortName || props.item?.shortName || props.item?.name

  const itemNotes = props.item?.notes

  return (
    <View style={styles.main}>
      <View style={styles.item}>
        <Text style={styles.quantity}>{props.item.quantity}x</Text>
        <Text style={styles.value}>
          <Text style={styles.itemName}>{itemShortName}</Text>
          {/* {props.item.item.sku && <Text style={styles.sku}>{`  (${props.item.item.sku})`}</Text>} */}
        </Text>
        <Text style={styles.price}>{price}</Text>
      </View>
      {props.item.choices.map((choice, i) => {
        const choicePrice =
          choice.price > 0 ? props.formatter.format(choice.price) : ""
        return (
          <View style={styles.choice} key={i}>
            <Text style={styles.Value}>
              <Text style={styles.itemName}>
                - {choice.shortName || choice.name || choice.instruction}
              </Text>
              {/* {choice.sku && <Text style={styles.sku}>{`  (${choice.sku})`}</Text>} */}
            </Text>
            <Text style={styles.price}>{choicePrice}</Text>
          </View>
        )
      })}
      {itemNotes && (
        <View>
          <Text style={styles.notes}>Notes: {itemNotes}</Text>
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: Base.colours.appSemiLightGrey,
  },

  item: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  choice: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: 40,
    marginVertical: 8,
  },

  quantity: {
    fontFamily: Base.fonts.appExtraBold,
    fontSize: 17,
    color: Base.colours.appDarkBlue,
  },

  itemName: {
    fontFamily: Base.fonts.appSemiBold,
    fontSize: 17,
  },

  sku: {
    fontFamily: Base.fonts.appRegular,
    fontSize: 17,
    color: Base.colours.appGrey,
  },

  value: {
    flexDirection: "row",
    flex: 1,
    marginHorizontal: 12,
    fontFamily: Base.fonts.appSemiBold,
  },

  price: {
    fontFamily: Base.fonts.appRegular,
    color: Base.colours.appBlack,
    fontSize: 16,
  },

  notes: {
    color: Base.colours.appGreen,
    fontFamily: Base.fonts.appRegular,
    fontSize: 12,
    paddingVertical: 4,
  },
})
